/** Catches a crashing page so the app shell stays up, and offers a retry instead of a white screen. */
import React from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';
import { Button } from './ui/button';

export class PageErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, attempt: 0 };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error) {
    console.error('Page crashed:', error);
    if (/Loading chunk|ChunkLoadError|dynamically imported module/i.test(String(error?.message)) && !sessionStorage.getItem('chunk-reloaded')) {
      sessionStorage.setItem('chunk-reloaded', '1');
      window.location.reload();
    }
  }

  render() {
    if (!this.state.error) return <React.Fragment key={this.state.attempt}>{this.props.children}</React.Fragment>;
    return (
      <div className="flex flex-col items-center justify-center gap-3 py-24 text-center" data-testid="page-error-state">
        <AlertTriangle className="h-8 w-8 text-amber-500" />
        <p className="font-medium">This page didn't load.</p>
        <p className="max-w-md text-sm text-muted-foreground" data-testid="page-error-message">Something went wrong on our side. Try again — if it keeps happening, let your admin know.</p>
        <Button onClick={() => this.setState((s) => ({ error: null, attempt: s.attempt + 1 }))} data-testid="page-error-retry-btn">
          <RefreshCw className="mr-2 h-4 w-4" /> Try again</Button>
      </div>
    );
  }
}
